import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Bestcabserviceinmumbai() {



  const cardData = {
    keyword: " Best Cab Service in Mumbai  ",


"headingDescription": "Royal Route Cab offers one of the best cab services in Mumbai, providing safe, reliable, and affordable travel solutions for local rides, airport transfers, corporate travel, daily commuting, and outstation journeys. With a strong focus on punctuality, clean vehicles, transparent pricing, and professional drivers, we ensure a smooth and stress-free travel experience across Mumbai and nearby cities. Whether you need a quick city ride or a long-distance trip, our fleet of sedans, SUVs, Innova, Ertiga, Innova Crysta, luxury cars, and Tempo Travellers is available 24/7 to meet every travel requirement. Easy online booking, instant support, and no hidden charges make Royal Route Cab a trusted choice for the best cab service in Mumbai.",

"topPlaces": [
  {
    "title": "Best Cab Service in Mumbai",
    "description": "Best cab service in Mumbai offers reliable, safe, and comfortable transportation for local travel, airport transfers, and outstation journeys. It is widely preferred by families, tourists, and business travelers for hassle-free booking and professional service."
  },
  {
    "title": "Mumbai to Pune Cab Service",
    "description": "Mumbai to Pune cab service is one of the most popular intercity routes, offering a comfortable and smooth journey for business trips, weekend getaways, and daily travel between the two cities."
  },
  {
    "title": "Mumbai to Goa Cab Service",
    "description": "Mumbai to Goa cab service is ideal for long scenic road trips, providing a comfortable and private travel experience for families and groups heading to Goa’s beaches and tourist destinations."
  },
  {
    "title": "Mumbai to Nashik Cab Service",
    "description": "Mumbai to Nashik cab service is commonly used for religious trips, vineyard visits, and weekend travel. It offers a convenient and comfortable ride for families and groups."
  },
  {
    "title": "Mumbai to Lonavala Cab Service",
    "description": "Mumbai to Lonavala cab service is popular for short weekend trips, providing a quick and relaxing escape from the city to the scenic hill station."
  },
  {
    "title": "Mumbai to Shirdi Cab Service",
    "description": "Mumbai to Shirdi cab service is preferred by pilgrims visiting the famous Sai Baba temple. It ensures a safe and comfortable journey for families and devotees."
  },
  {
    "title": "Mumbai Airport Transfer Cab Service",
    "description": "Mumbai airport transfer cab service provides timely pickup and drop facilities for domestic and international travelers, ensuring a smooth and stress-free journey."
  },
  {
    "title": "Mumbai Local City Cab Service",
    "description": "Mumbai local city cab service is ideal for daily commuting, office travel, shopping, and short-distance rides within the city at affordable rates."
  },
  {
    "title": "Mumbai to Mahabaleshwar Cab Service",
    "description": "Mumbai to Mahabaleshwar cab service is a popular choice for hill station vacations, offering a comfortable long-distance ride through scenic routes."
  },
  {
    "title": "One Way Cab Service from Mumbai",
    "description": "One way cab service from Mumbai allows passengers to book single-direction travel to nearby cities at cost-effective rates without return charges."
  }
],






services: [
  {
    name: "Best Cab Service in Mumbai",
    description: "Best cab service in Mumbai offers top-quality transportation with well-maintained vehicles and professional drivers. This service focuses on comfort, safety, and punctuality for all travel needs. Ideal for local, airport, and outstation trips. It guarantees a premium and reliable travel experience."
  },
  {
    name: "Top Taxi Service Mumbai",
    description: "Top taxi service Mumbai provides highly rated transportation options for daily commuting and long-distance travel. This service is known for reliability and customer satisfaction. Clean vehicles and experienced drivers ensure comfort. It guarantees a smooth journey."
  },
  {
    name: "Reliable Cab Service Mumbai",
    description: "Reliable cab service Mumbai ensures dependable travel with consistent service quality. This service is ideal for office commutes, airport transfers, and outstation trips. Professional drivers ensure timely service. It guarantees a stress-free experience."
  },
  {
    name: "Affordable Taxi Service Mumbai",
    description: "Affordable taxi service Mumbai offers budget-friendly travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers. Transparent pricing ensures no hidden charges. It ensures economical travel."
  },
  {
    name: "Cheap Cab Service Mumbai",
    description: "Cheap cab service Mumbai provides economical transportation solutions for daily travel needs. This service offers reliable vehicles at low fares. Suitable for local travel and short trips. It ensures cost-effective journeys."
  },
  {
    name: "Premium Cab Service Mumbai",
    description: "Premium cab service Mumbai offers high-end vehicles and superior comfort for luxury travel. This service is ideal for business executives and special occasions. Professional chauffeurs enhance the experience. It guarantees a premium journey."
  },
  {
    name: "Luxury Taxi Service Mumbai",
    description: "Luxury taxi service Mumbai provides top-class vehicles with advanced features for a stylish travel experience. This service is ideal for VIP travel and corporate clients. Comfortable interiors enhance long journeys. It ensures a luxurious ride."
  },
  {
    name: "24x7 Cab Service Mumbai",
    description: "24x7 cab service Mumbai ensures round-the-clock availability for all travel needs. This service is ideal for late-night rides, early morning trips, and emergency travel. Quick booking and reliable drivers ensure convenience. It guarantees service anytime."
  },
  {
    name: "Airport Cab Service Mumbai",
    description: "Airport cab service Mumbai provides timely pickup and drop to all airport terminals. This service ensures punctual travel for flights. Professional drivers and clean vehicles enhance comfort. It guarantees a stress-free airport experience."
  },
  {
    name: "Local Taxi Service Mumbai",
    description: "Local taxi service Mumbai offers convenient transportation for short-distance travel within the city. This service is ideal for office commutes, shopping, and daily errands. Flexible booking enhances convenience. It ensures smooth city travel."
  },
  {
    name: "Outstation Cab Service Mumbai",
    description: "Outstation cab service Mumbai provides reliable travel to nearby cities and long-distance destinations. This service includes one way and round trip options. Vehicles are maintained for highway travel. It ensures a safe and comfortable journey."
  },
  {
    name: "Corporate Cab Service Mumbai",
    description: "Corporate cab service Mumbai offers professional travel solutions for businesses and organizations. This service includes employee transport, executive travel, and corporate events. Reliable drivers ensure punctual service. It ensures efficient business travel."
  },
  {
    name: "Trusted Cab Providers Mumbai",
    description: "Trusted cab providers Mumbai ensure dependable transportation with verified drivers and well-maintained vehicles. This service focuses on safety and customer satisfaction. Suitable for all travel needs. It guarantees a reliable experience."
  },
  {
    name: "Professional Taxi Service Mumbai",
    description: "Professional taxi service Mumbai offers high-quality transportation with trained chauffeurs and well-maintained vehicles. This service is ideal for business and personal travel. It ensures punctual and comfortable journeys."
  },
  {
    name: "Safe Cab Service Mumbai",
    description: "Safe cab service Mumbai prioritizes passenger safety with verified drivers and secure travel practices. This service is ideal for families, solo travelers, and late-night rides. It ensures a secure and comfortable journey."
  },
  {
    name: "Verified Taxi Service Mumbai",
    description: "Verified taxi service Mumbai provides trusted travel solutions with background-checked drivers and reliable vehicles. This service ensures safety and transparency for all trips. It guarantees a dependable travel experience."
  }
],

tableData: [
  ["Best Cab Service in Mumbai", "Top Taxi Service Mumbai"],
  ["Reliable Cab Service Mumbai", "Affordable Taxi Service Mumbai"],
  ["Cheap Cab Service Mumbai", "Premium Cab Service Mumbai"],
  ["Luxury Taxi Service Mumbai", "24x7 Cab Service Mumbai"],
  ["Airport Cab Service Mumbai", "Local Taxi Service Mumbai"],
  ["Outstation Cab Service Mumbai", "Corporate Cab Service Mumbai"],
  ["Trusted Cab Providers Mumbai", "Professional Taxi Service Mumbai"],
  ["Safe Cab Service Mumbai", "Verified Taxi Service Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Best Cab Service in Mumbai",
    WhyChoosedescription: "Royal Route Cabs is recognized as one of the best cab services in Mumbai, offering reliable rides for local travel, airport transfers, and outstation journeys."
  },
  {
    WhyChooseheading: "Professional & Verified Drivers",
    WhyChoosedescription: "Our drivers are trained, experienced, and verified, ensuring safe, polite, and smooth travel across Mumbai city."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "We provide clear and upfront pricing so customers never face unexpected charges during or after the ride."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Royal Route Cabs operates round the clock, making it easy to book a cab anytime for daily travel or urgent requirements."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Vehicles",
    WhyChoosedescription: "All our cabs are regularly serviced, sanitized, and maintained to ensure a safe and comfortable ride experience."
  },
  {
    WhyChooseheading: "Multiple Travel Options",
    WhyChoosedescription: "We offer local cab service, airport transfers, corporate travel, and outstation trips from Mumbai with flexible packages."
  },
  {
    WhyChooseheading: "Wide Range of Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and mini buses."
  },
  {
    WhyChooseheading: "Trusted by Thousands of Customers",
    WhyChoosedescription: "Customers trust Royal Route Cabs for punctual service, easy booking, and smooth travel experience across Mumbai."
  }
]

};

const faqData = [
  { question: "Which is the best cab service in Mumbai?", answer: "Royal Route Cabs is one of the best cab service providers in Mumbai known for reliability, clean cars, and professional drivers." },
  { question: "Is cab service available 24 hours in Mumbai?", answer: "Yes, our Mumbai cab service operates 24/7." },
  { question: "Do you provide airport cab service?", answer: "Yes, we offer airport pickup and drop from Mumbai Airport." },
  { question: "Which vehicles are available?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, Tempo Travellers, and mini buses." },
  { question: "Can I book cab for outstation travel?", answer: "Yes, we provide outstation cab services from Mumbai to multiple destinations." },
  { question: "Is pricing transparent?", answer: "Yes, we provide clear pricing with no hidden charges." },
  { question: "Do you provide corporate cab services?", answer: "Yes, we offer corporate travel solutions including employee transportation." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from home, hotel, and office anywhere in Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for peak hours and long-distance travel." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Sharma",
    feedback:
      "Best cab service in Mumbai! Very professional driver and clean car. Highly recommended.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Verma",
    feedback:
      "Excellent cab service experience. On-time pickup and very comfortable ride across Mumbai.",
    rating: 5
  }
];










  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Best Cab Service in Mumbai",
  "image": "https://www.royalroutecabs.com/assets/images/best-cab-service-mumbai.jpg", // replace if needed
  "description": "Book the best cab service in Mumbai with Royal Route Cabs. Trusted for local rides, airport transfers, outstation travel, and corporate bookings. Safe, affordable, and available 24x7 across Mumbai.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "499", // starting fare (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/best-cab-service-in-mumbai"
  }
};





  return (
    <div>
<Helmet>
  <title>Best Cab Service in Mumbai | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Looking for the best cab service in Mumbai? Royal Route Cabs offers safe, reliable, and affordable taxi services for local, airport, outstation, and corporate travel 24x7."
  />

  <meta
    name="keywords"
    content="best cab service in mumbai, top taxi service mumbai, reliable cab service mumbai, affordable taxi service mumbai, cheap cab service mumbai, premium cab service mumbai, luxury taxi service mumbai, 24x7 cab service mumbai, airport cab service mumbai, local taxi service mumbai, outstation cab service mumbai, corporate cab service mumbai, trusted cab providers mumbai, professional taxi service mumbai, safe cab service mumbai, verified taxi service mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/52.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bestcabserviceinmumbai;